import { SignInForm } from '@components/Auth/SignInForm';

export const SignInPage = () => {
  return <SignInForm />;
};
